/* Nieveando · efectos */
(function(){
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Snow(host){
    host.classList.add('nv-js-snow');
    var c = document.createElement('canvas'); c.className = 'nv-snowfx'; c.setAttribute('aria-hidden','true');
    host.appendChild(c);
    var ctx = c.getContext('2d'), W=0, H=0, dpr=Math.min(window.devicePixelRatio||1,2), flakes=[], wind=0, tw=0, run=false, raf=0;
    function size(){ var r=host.getBoundingClientRect(); W=r.width; H=r.height; c.width=W*dpr; c.height=H*dpr; c.style.width=W+'px'; c.style.height=H+'px'; ctx.setTransform(dpr,0,0,dpr,0,0);
      var n=Math.round(Math.min(140, W*H/9000)); while(flakes.length<n) flakes.push(mk(true)); flakes.length=n; }
    function mk(any){ var z=Math.random(); return {x:Math.random()*W, y:any?Math.random()*H:-10, r:.8+z*2.8, s:.25+z*1.1, o:.35+z*.6, a:Math.random()*6.28, w:.5+Math.random()*1.5}; }
    function tick(){ ctx.clearRect(0,0,W,H); wind+=(tw-wind)*.02;
      for(var i=0;i<flakes.length;i++){ var f=flakes[i]; f.a+=.01*f.w; f.y+=f.s; f.x+=Math.sin(f.a)*.4+wind*f.s;
        if(f.y>H+6||f.x<-10||f.x>W+10){ var g=mk(false); g.x=Math.random()*W; flakes[i]=g; continue; }
        ctx.globalAlpha=f.o; ctx.beginPath(); ctx.arc(f.x,f.y,f.r,0,6.283); ctx.fillStyle='#fff'; ctx.fill(); }
      raf=requestAnimationFrame(tick); }
    function start(){ if(!run){ run=true; raf=requestAnimationFrame(tick);} }
    function stop(){ run=false; cancelAnimationFrame(raf); }
    host.addEventListener('mousemove',function(e){ var r=host.getBoundingClientRect(); tw=((e.clientX-r.left)/r.width-.5)*2.2; });
    host.addEventListener('mouseleave',function(){ tw=0; });
    new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?start():stop(); }); }).observe(host);
    window.addEventListener('resize',size); size();
  }

  function reveal(){
    var sel = '.nv-head,.nv-cat,.nv-tcard,.nv-feat,.nv-value,.nv-strip,.nv-split,.nv-cta,.nv-timeline,.nv-steps li,.nv-mcard,.nv-qa,.nv-hcard,.nv-track__card,.nv-promo,.nv-about__story,.nv-about__collage,.product-grid .grid__item,.collapsible-content .accordion,.nv-faqp__title';
    var els = document.querySelectorAll(sel);
    if(RM || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){
      var p = el.parentElement, i = p ? Array.prototype.indexOf.call(p.children, el) : 0;
      el.classList.add('nv-rv'); el.style.setProperty('--d', Math.min(i,6)*70+'ms'); io.observe(el);
    });
  }

  function parallax(){
    if(RM) return;
    document.querySelectorAll('.nv-hero__art,.nv-chero__art,.nv-about__collage').forEach(function(art){
      var host = art.closest('section') || art;
      host.addEventListener('mousemove',function(e){ var r=host.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        art.querySelectorAll('.nv-pol,.nv-sticker,.nv-chero__count').forEach(function(p,i){ var k=(i%3+1)*7; p.style.translate=(x*k)+'px '+(y*k)+'px'; }); });
      host.addEventListener('mouseleave',function(){ art.querySelectorAll('.nv-pol,.nv-sticker,.nv-chero__count').forEach(function(p){ p.style.translate=''; }); });
    });
  }

  function burst(x,y){
    if(RM) return;
    var cols=['#FFD23F','#FF5C8A','#5BC8FF','#3DDC97','#fff'];
    for(var i=0;i<18;i++){ var s=document.createElement('span'); s.className='nv-burst'; s.textContent='❄';
      var a=Math.random()*6.283, d=60+Math.random()*90;
      s.style.left=x+'px'; s.style.top=y+'px'; s.style.color=cols[i%cols.length];
      s.style.setProperty('--x',Math.cos(a)*d+'px'); s.style.setProperty('--y',(Math.sin(a)*d-40)+'px'); s.style.setProperty('--r',(Math.random()*540-270)+'deg');
      s.style.fontSize=(12+Math.random()*14)+'px'; document.body.appendChild(s); setTimeout(function(n){ return function(){ n.remove(); }; }(s),1100); }
  }
  document.addEventListener('click',function(e){
    var b = e.target.closest('.product-form__submit,[name="add"]'); if(!b) return;
    var r=b.getBoundingClientRect(); burst(r.left+r.width/2, r.top+r.height/2);
  });

  document.addEventListener('click',function(e){
    var b = e.target.closest('[data-nv-copy]'); if(!b) return;
    var code=b.getAttribute('data-nv-copy');
    var done=function(){ b.classList.add('is-copied'); var t=b.querySelector('[data-nv-copy-label]'); if(t){ var o=t.getAttribute('data-o')||t.textContent; t.setAttribute('data-o',o); t.textContent='¡Copiado!'; setTimeout(function(){ t.textContent=o; b.classList.remove('is-copied'); },1800);} var r=b.getBoundingClientRect(); burst(r.left+r.width/2, r.top+r.height/2); };
    if(navigator.clipboard){ navigator.clipboard.writeText(code).then(done,done); } else { done(); }
  });

  function header(){
    var h=document.querySelector('.section-header'); if(!h) return;
    var f=function(){ document.documentElement.classList.toggle('nv-scrolled', window.scrollY>20); };
    window.addEventListener('scroll',f,{passive:true}); f();
  }

  function nvCount(){
    var n=document.querySelectorAll('#ProductGridContainer .nv-vcard').length; if(!n) return;
    var t=n+(n===1?' modelo':' modelos');
    document.querySelectorAll('#ProductCount,#ProductCountDesktop').forEach(function(el){ if(el.textContent.trim()!==t) el.textContent=t; });
  }

  function init(){
    if(!RM) document.querySelectorAll('.nv-hero,.nv-chero,.nv-phero,.nv-404,.nv-promo__ticket').forEach(function(h){ Snow(h); });
    reveal(); parallax(); header(); nvCount();
    var pg=document.getElementById('ProductGridContainer'); if(pg) new MutationObserver(function(){ nvCount(); }).observe(pg,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
